module.exports = __webpack_public_path__ + "img/Cheer Megaphone30.81f6c992.jpg";